import { render, staticRenderFns } from "./DialogEditStaffPassword.vue?vue&type=template&id=6db0942b&"
import script from "./DialogEditStaffPassword.vue?vue&type=script&lang=js&"
export * from "./DialogEditStaffPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports